import { ReviewPurchaseOrderConfirmationFormData } from "src/types";

export class ReviewPurchaseOrderConfirmationMapper {
  public static initReviewPurchaseOrderConfirmationFormData(): ReviewPurchaseOrderConfirmationFormData {
    return {
      purchaseOrderId: "",
      cancellationReason: "",
      createBackorderPO: false
    };
  }
}
